module.exports = __webpack_public_path__ + "static/media/M1-33-Fúria-do-Dragão-cod152.fc809748.png";